@if (data && data.tag) {
  <div class="mb-4 text-center text-gray-300 text-2xl sm:text-3xl leading-7 sm:leading-9" >
    {{ data.tag }} Templates
  </div>
}

@if (data && data.description) {
  <div>
    <div class="ck-content leading-8 clearfix ck-editor-style overflow-auto" [innerHtml]="data.description | safeHtml">
    </div>
  </div>
}
